import { z } from "zod";

export const resetPasswordRequestSchema = z.object({
  // 32-byte base64url (no padding) = exactly 43 chars; bounds length + charset, rejecting
  // oversized/garbage tokens before they ever reach the server-side hash + DB lookup.
  token: z.string().regex(/^[A-Za-z0-9_-]{43}$/, "Invalid reset token"),
  password: z.string().min(12, "Password must be at least 12 characters"),
});
